import {SyntheticEvent} from 'react';
import {TrackingContextValue} from '@homeaway/react-event-tracking';
import {getFilterId} from './filters';

// Event names
export const GENERIC_EVENT = 'generic.event';
export const FILTER_BAR_PRESENTED = 'filter_bar.presented';
export const FILTER_GROUP_PRESENTED = 'filter_group.presented';
export const FILTER_GROUP_HIDDEN = 'filter_group.hidden';
export const FILTER_GROUP_VIEW_ALL_SELECTED = 'filter_group_view_all.selected';
export const FILTER_GROUP_CLEAR_SELECTED = 'filter_group_clear.selected';
export const FILTER_GROUP_MORE_FILTERS_PRESENTED =
    'filter_group_more_filters.presented';
export const FILTER_GROUP_MORE_FILTERS_HIDDEN =
    'filter_group_more_filters.hidden';
export const FILTER_GROUP_MORE_FILTERS_CLEAR_SELECTED =
    'filter_group_more_filters_clear.selected';
export const FILTER_CHECK_SELECTED = 'filter_check.selected';
export const FILTER_CHECK_UNCHECK_SELECTED = 'filter_check_uncheck.selected';
export const PRICE_FILTER_SUBMITTED = 'price_filter.submitted';
export const FILTER_ROOMS_INPUTTED = 'filter_rooms.inputted';
export const triggerEdapEventForCheckbox = (
    event: SyntheticEvent<HTMLInputElement>,
    groupId: string,
    rank: number,
    tracking: TrackingContextValue
) => {
    const eventName = event.currentTarget.checked
        ? FILTER_CHECK_SELECTED
        : FILTER_CHECK_UNCHECK_SELECTED;
    tracking.trigger(eventName, {
        filtergroupid: groupId,
        filterid: getFilterId(event),
        rank: `${rank}`,
    });
};
